import { useConfirm } from "material-ui-confirm";
import { useSnackbar } from "notistack";
import { useState } from "react";
import { Link } from "react-router-dom";

import { Card, CardHeader, CardContent, Button } from "@material-ui/core";

import { subaccountsEnable } from "src/graphql/generated/subaccountsEnable";
import { ENABLE_TENANT_SUBACCOUNTS } from "src/graphql/tenant";
import useMutation from "src/util/useMutation";

export default function OrgSubaccountsEnable(): JSX.Element {
  const snackbar = useSnackbar();
  const confirm = useConfirm();
  const [loading, setLoading] = useState(false);

  const [enableSubaccounts] = useMutation<subaccountsEnable>(
    ENABLE_TENANT_SUBACCOUNTS,
    {
      onErrorSnackbarMessage: `Failed to enable subaccounts.`
    }
  );

  async function handleEnable() {
    const { errors } = await enableSubaccounts();

    if (!errors) {
      snackbar.enqueueSnackbar("Subaccounts enabled.", { variant: "info" });
    }
  }

  async function handleClick() {
    try {
      await confirm({
        title: "Are you sure?",
        description:
          "Are you sure you want to enable subaccounts? You can't undo this action."
      });
    } catch {
      // user cancelled
      return;
    }

    setLoading(true);
    await handleEnable();
    setLoading(false);
  }

  return (
    <>
      <Card>
        <CardHeader title="Name" />
        <CardContent>
          <p>
            Subaccounts allow you to divide up your dialer organization. If you
            enable this feature, you&apos;ll be able to create as many
            subaccounts as you&apos;d like. Each subaccount will have its own
            admin interface, containing its own call campaigns, settings,
            integrations, admins, and Do Not Call List.
          </p>
          <p>
            You&apos;ll be able to add Admins and Owners to each of your
            subaccounts. You can add any Admins and Owners to multiple
            subaccounts, or have separate Admins and Owners for each one.
          </p>
          <p>
            Users whom you promote to be{" "}
            <Link to="/organization/owners">Organization Owners</Link> will
            automatically have access to and be able to manage all current and
            future subaccounts of this dialer organization. They will also be
            able to create new subaccounts.
          </p>
          <p>
            <Button
              onClick={handleClick}
              disabled={loading}
              color="primary"
              variant="contained"
            >
              {loading ? "Enabling..." : "Enable Subaccounts"}
            </Button>
          </p>
        </CardContent>
      </Card>
    </>
  );
}
